// 配送情報(product-deliverydate.liquidで定義)
window._deliveryDateInfo = {};

// 日付を%Y/%m/%dにフォーマットする(セパレータが指定されたその値で分割)
function formatDate (date, separator="/") {
    if (!(date instanceof Date))date = new Date(date);
    return `${date.getFullYear()}${separator}${("00"+(date.getMonth()+1)).slice(-2)}${separator}${("00"+date.getDate()).slice(-2)}`;
}
// 日付を加算する
function addDate (date, adder) {
    if (!(date instanceof Date))date = new Date(date);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()+adder,date.getHours(), date.getMinutes(), date.getSeconds());
}
// 営業日ベースで加算する
function addWorkDate (date, adder) {
    if (!(date instanceof Date))date = new Date(date);
    for (let ii = 0; ii < adder; ii++) {
        date = getWorkDate(addDate(date, 1));
    }
    return date;
}

// 休業日情報保持
const _stHoliday = new Set();
function getHoliday () {
    if (_stHoliday.size > 0)return _stHoliday;
    if (!window._Holiday)return;
    window._Holiday.forEach(function(v){
        _stHoliday.add(formatDate(new Date(v)));
    });
    return _stHoliday;
}
// 休業曜日情報保持
const _stCloseday = new Set();
function getCloseday () {
    if (_stCloseday.size > 0)return _stCloseday;
    if (!window._Closeday)return;
    window._Closeday.forEach(function(v){
        _stCloseday.add(v);
    });
    return _stCloseday;
}
// 営業日取得
function getWorkDate (date) {
    if (!(date instanceof Date))date = new Date(date);
    if (!getCloseday() || !getHoliday())return date;
    const dateFormat = formatDate(date);
    // 休業日の場合、翌営業日で再帰処理を行う
    if (getCloseday().has(date.getDay()) || getHoliday().has(dateFormat)) {
        return getWorkDate(addDate(date, 1));
    }
    // そうでない場合は、指定された日付を取得する
    return date;
}


// 発送日
function getSendDate (variantId, isQuick) {
    // 出荷予定日数を取得
    const orderCreateTerm = (window._deliveryDateInfo.variants[variantId] ?? {"order_create_term":null}).order_create_term;
    // 出荷予定日が指定されていない場合はnull
    if (!orderCreateTerm)return null;

    // クイックデリバリーにチェックが付いている場合、クイックデリバリーの出荷予定日を返却
    if (isQuick) {
        // クイックデリバリー日数を加算
        return addWorkDate(window._deliveryDateInfo["today"], (window,_deliveryDateInfo["quickdelivery_count"]));
    }

    // 設定している出荷予定日数 = 発送日
    // 出荷予定日数を加算
    return addWorkDate(window._deliveryDateInfo["today"], orderCreateTerm);
}

// 配送日
function getDeliveryDate (variantId, isQuick) {
    const variantStatus     = (window._deliveryDateInfo.variants[variantId] ?? {"status":window._deliveryDateInfo.status.unknown}).status;
    const releaseDate       = (window._deliveryDateInfo.variants[variantId] ?? {"release_date":null}).release_date;
    const deliveryDateCount = (window._deliveryDateInfo.variants[variantId] ?? {"delivery_date_count":0}).delivery_date_count;
    // 予約注文の場合
    if (variantStatus === window._deliveryDateInfo.status.reserve) {
        // 発売日+20日(予約発送日数)
        return addDate(releaseDate, window._deliveryDateInfo["reserve_delivery_date_count"]);
    // それ以外の場合
    } else {
        // 配送日数を発送日に追加する
        return addDate(getSendDate(variantId, isQuick), Number(deliveryDateCount));
    }
}


new Promise((resolve, reject)=>{
    const initTime = new Date().getTime();
    const timer = setInterval(()=>{
        // 休業日情報が取得できた場合
        if (window._Holiday && window._Closeday) {
            resolve();
            clearInterval(timer);
            return;
        }
        // 10秒経過したら終了
        if (new Date().getTime() - initTime > 10000) {
            reject();
            clearInterval(timer);
        }
    },500);
})
.then(()=>{
    // 休業日情報が取得できたらイベント発火する
    window.dispatchEvent(new CustomEvent("readyHolidy"));
});
